import { j as l } from "../../../_virtual/jsx-runtime.js";
import { forwardRef as n } from "react";
import { cn as o } from "../../../lib/utils.js";
import { cva as g } from "../../../node_modules/class-variance-authority/dist/index.js";
const b = g(
  "ui-library relative rounded-lg p-4 shadow-wrapper w-full",
  {
    variants: {
      bgColorVariant: {
        white: "bg-white text-grey-600",
        light: "bg-neteera-teal-200 text-grey-600",
        dark: "bg-neteera-teal-800 text-white",
        darkGradient: "base-card-angular-gradient text-white",
        blueGradient: "base-card-angular-blue-gradient text-white"
      }
    },
    defaultVariants: {
      bgColorVariant: "white"
    }
  }
), m = n(
  ({
    children: a,
    background: e,
    className: r = "",
    bgColorVariant: t,
    onMouseOver: i,
    onMouseLeave: s
  }, d) => /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: d,
      className: o(b({ bgColorVariant: t, className: r })),
      style: { background: e },
      onMouseOver: i,
      onMouseLeave: s,
      children: a
    }
  )
);
m.displayName = "BaseCard";
export {
  m as default
};
